import { defineMessages } from 'react-intl';
export const MENU_WIDTH_PX = 280;
export const EFFORT_BY_REASONING = {
    none: 'none',
    minimal: 'minimal',
    low: 'low',
    medium: 'medium',
    high: 'high',
    xhigh: 'xhigh',
    max: 'max',
};
const SELECTABLE_EFFORTS = [
    'minimal',
    'low',
    'medium',
    'high',
    'xhigh',
    'max',
];
export const messages = defineMessages({
    model: {
        defaultMessage: 'Model',
        description: 'Label for selecting an orchestrator model in Computer effort settings',
        id: '6e9962845f',
    },
    orchestratorEffort: {
        defaultMessage: 'Reasoning',
        description: 'Label for selecting model reasoning in Computer effort settings',
        id: '903233ffca',
    },
    none: {
        defaultMessage: 'None',
        description: 'No reasoning effort option',
        id: 'dab5be10f5',
    },
    minimal: {
        defaultMessage: 'Minimal',
        description: 'Minimal reasoning effort option',
        id: 'e2cb6aca26',
    },
    low: {
        defaultMessage: 'Low',
        description: 'Low reasoning effort option',
        id: '06327bdf63',
    },
    medium: {
        defaultMessage: 'Medium',
        description: 'Medium reasoning effort option',
        id: '2a2826fdcc',
    },
    high: {
        defaultMessage: 'High',
        description: 'High reasoning effort option',
        id: '05d72d008e',
    },
    xhigh: {
        defaultMessage: 'Extra High',
        description: 'Extra-high reasoning effort option',
        id: 'af781e49e9',
    },
    max: {
        defaultMessage: 'Max',
        description: 'Maximum reasoning effort option',
        id: '0a08e792ab',
    },
});
export const EFFORT_MESSAGES = {
    none: messages.none,
    minimal: messages.minimal,
    low: messages.low,
    medium: messages.medium,
    high: messages.high,
    xhigh: messages.xhigh,
    max: messages.max,
};
export const getOptions = (allowed) => SELECTABLE_EFFORTS.filter((level) => allowed.includes(level));
//# sourceMappingURL=ComputerEffortMenuItemsShared.js.map